import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Utility for creating HTTP headers that prevent caching
 */
export const NO_CACHE_HEADERS = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0'
};

/**
 * Creates HTTP options with cache-busting headers
 * @param additionalHeaders Optional additional headers to include
 * @returns HTTP options object with cache-busting headers
 */
export function createNoCacheOptions(additionalHeaders: Record<string, string> = {}) {
  return {
    headers: {
      ...NO_CACHE_HEADERS,
      ...additionalHeaders
    }
  };
}

/**
 * JWT + API key for multipart recording uploads. Sends both api-key and X-Api-Key
 * because some proxies strip non-standard header names; checkpoint upload does not
 * require api-key at the controller but finalize does validate when present.
 */
export function buildApiAuthHeaders(contentType?: string): HttpHeaders {
  let headers = new HttpHeaders();
  if (contentType) {
    headers = headers.set('Content-Type', contentType);
  }
  const token = typeof window !== 'undefined' ? localStorage.getItem('jwt_token') : null;
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }
  const key = environment.apiKey;
  if (key) {
    headers = headers.set('api-key', key);
    headers = headers.set('X-Api-Key', key);
  }
  return headers;
}

/** Header map for interceptor refresh/retry (plain object for HttpClient setHeaders). */
export function apiAuthHeaderMap(): Record<string, string> {
  const map: Record<string, string> = {};
  const token = typeof window !== 'undefined' ? localStorage.getItem('jwt_token') : null;
  if (token) {
    map['Authorization'] = `Bearer ${token}`;
  }
  const key = environment.apiKey;
  if (key) {
    map['api-key'] = key;
    map['X-Api-Key'] = key;
  }
  return map;
}
